import { put, select } from 'redux-saga/effects';
import { createAction, createAsyncAction, createReducer } from 'typesafe-actions';
import { gfLoaded } from 'utils/dynamic-yields';
import { getIsContentChanged } from './selectors';

export const INIT_GF_CAMPAIGN = createAsyncAction(
  'dy/INIT_GF_CAMPAIGN/request',
  'dy/INIT_GF_CAMPAIGN/success',
  'dy/INIT_GF_CAMPAIGN/failure',
  'dy/INIT_GF_CAMPAIGN/cancel'
)<void, void, void, void>();

export const RESET_GF_CAMPAIGN = createAction('dy/RESET_GF_CAMPAIGN')();

export const SET_CONTENT_CHANGED = createAction('dy/SET_CONTENT_CHANGED')<boolean>();

export const SEND_SPA_EVENT = createAction('dy/SEND_SPA_EVENT')<boolean>();
export const SEND_CATALOG_SPA_EVENT = createAction('dy/SEND_CATALOG_SPA_EVENT')<boolean>();

export const isGfCampaignLoaded = createReducer(false)
  .handleAction(INIT_GF_CAMPAIGN.success, () => true)
  .handleAction(RESET_GF_CAMPAIGN, () => {
    // Удаляем gf_campaign из window вручную, поскольку в SPA при переходе по каталогу
    // или добавлении/удалении фильтров gf_campaign не очищается
    delete window.gf_campaign;
    return false;
  })
  .handleAction(INIT_GF_CAMPAIGN.failure, () => false);

export const isContentChanged = createReducer<boolean>(false).handleAction(
  SET_CONTENT_CHANGED,
  (_, { payload }) => payload
);

export function* runSpaEvent(checkContentChanges: boolean): Generator {
  const countAsPageView = yield select(getIsContentChanged);
  if (checkContentChanges && !countAsPageView) {
    return;
  }

  yield put(RESET_GF_CAMPAIGN());
  if (countAsPageView) {
    yield put(SET_CONTENT_CHANGED(false));
  }

  yield put(SEND_CATALOG_SPA_EVENT(countAsPageView as boolean));
}

export function* runGfCampaignCheck() {
  try {
    yield gfLoaded();
    yield put(INIT_GF_CAMPAIGN.success());
  } catch (e) {
    yield put(INIT_GF_CAMPAIGN.failure());
  }
}
